export default {
  Text: '文本',
  Type: '類型',
  Target: '目的',
  Generate: '生成',
  Generating: '生成中',
  optimize_text: {
    des: 'Al-書寫更精準，自然流暢',
    Save_and_New: '保存並新建'
  }
}
